/**
 * Label row with optional ? tooltip for flow meta fields.
 * For Media Devoted | Created By Ciro Autiero
 */

import { type FC } from 'react';

import { Tooltip } from '@/components/ui/Tooltip';

const FlowMetaFieldLabel: FC<{
  label: string;
  hint?: string;
  children?: React.ReactNode;
}> = ({ label, hint, children }) => (
  <div className="flex flex-col gap-1">
    <span className="inline-flex items-center gap-1.5">
      <span className="text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
        {label}
      </span>
      {hint ? (
        <Tooltip content={hint} side="right">
          <span
            className="cursor-help text-[10px] font-semibold tabular-nums text-primary/80"
            aria-label={hint}
          >
            ?
          </span>
        </Tooltip>
      ) : null}
    </span>
    {children}
  </div>
);

export default FlowMetaFieldLabel;
